import { SVGProps } from 'react'

export const Amex = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="15"
      height="4"
      viewBox="0 0 15 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.36487 0.215454L0.757324 3.93061H2.68178L2.92036 3.33826H3.46569L3.70427 3.93061H5.82256V3.47851L6.01131 3.93061H7.10705L7.29581 3.46895V3.93061H11.7013L12.237 3.35364L12.7385 3.93061L15.0013 3.93538L13.3887 2.0834L15.0013 0.215454H12.7736L12.2522 0.781758L11.7664 0.215454H6.97382L6.56228 1.17437L6.14109 0.215454H4.22065V0.652171L4.00701 0.215454H2.36487ZM8.94349 0.743015H11.4733L12.2471 1.61587L13.0458 0.743015H13.8195L12.6439 2.08288L13.8195 3.40731H13.0107L12.2369 2.52432L11.4342 3.40731H8.94349V0.743015ZM9.56826 1.7816V1.29494V1.29448H11.1468L11.8356 2.07276L11.1163 2.8553H9.56826V2.32401H10.9484V1.7816H9.56826ZM2.73721 0.743015H3.67528L4.74157 3.26228V0.743015H5.76919L6.59277 2.54932L7.35179 0.743015H8.37428V3.40888H7.75212L7.74704 1.31992L6.83999 3.40888H6.28344L5.37132 1.31992V3.40888H4.0914L3.84875 2.81123H2.5378L2.29566 3.40836H1.60989L2.73721 0.743015ZM2.76164 2.25876L3.19354 1.19409L3.62494 2.25876H2.76164Z"
        fill="white"
      />
    </svg>
  )
}
